export class ApiError extends Error {
  constructor(public data: ErrorStatusModel) {
    super(data.message)
    this.name = 'ApiError'
  }
}

export type ErrorStatusModel = {
  status: number
  error: string
  details: any
  message: string
  messageKey: string
  timestamp: string
  traceId: string
}

export type FieldDetails = {
  field: string
  value: string
}

export type ResourceDetails = {
  resource: string
  value: string
}
